module.exports = __webpack_public_path__ + "img/019-counselor.6284d9c7.png";